import * as Website from '../Config/Website.js';

const Toggle = {
  element: {
    item: '.js-toggle-item',
    content: '.js-toggle-content',
    close: '.js-toggle-close ,.js-toggle-overlay'
  },

  init() {
    // js-toggle-itemクリック時のトグル処理
    document.querySelectorAll(this.element.item).forEach(item => {
      item.addEventListener('click', () => {
        const targetId = item.dataset.toggleTarget;
        const content = document.querySelector(
          `${this.element.content}[data-toggle-id="${targetId}"]`
        );
        if (content) {
          content.classList.toggle(Website.classList.act);
          // スクロールロック制御
          if (content.classList.contains(Website.classList.act)) {
            document.documentElement.classList.add(Website.classList.modalOpen);
          } else {
            document.documentElement.classList.remove(Website.classList.modalOpen);
          }
        }
      });
    });

    // js-toggle-closeクリック時のクローズ処理
    document.querySelectorAll(this.element.close).forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        const parentContent = closeBtn.closest(this.element.content);
        if (parentContent) {
          parentContent.classList.remove(Website.classList.act);
          document.documentElement.classList.remove(Website.classList.modalOpen);
        }
      });
    });
  }
};

export default Toggle;
